module.exports = __webpack_public_path__ + "img/logo_text_en.4ea2b9ad.png";